module.exports = __webpack_public_path__ + "img/scene4-0.f1ee7ae4.jpg";